<h2
    mat-dialog-title
    class="tw-flex tw-items-center tw-gap-2">
    {{ 'ADMIN-PANEL.CLIENTS.TERMS.TITLE' | translate }}
</h2>

<mat-dialog-content class="terms-content">
    @if (loading()) {
        <div class="tw-flex tw-justify-center tw-py-8">
            <mat-spinner diameter="40"></mat-spinner>
        </div>
    } @else {
        <div
            [innerHTML]="tosText()"
            class="terms-text"></div>
    }
</mat-dialog-content>

<mat-dialog-actions align="end">
    <button
        mat-raised-button
        color="primary"
        (click)="close()">
        {{ 'GLOBAL.BUTTON.CLOSE' | translate }}
    </button>
</mat-dialog-actions>
